import { faCircleCheck } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";

import { DEFAULT_MODAL_DURATION_MS } from "../../constants";
import { Modal } from "../../shared/modal";
import { ModalButton } from "../../shared/modal-button";
import { ModalIcon } from "../../shared/modal-icon";
import { ModalTitle } from "../../shared/modal-title";

type ModalPrintingSuccessProps = {
  onClose: () => void;
  timeoutDuration?: number;
};

export const ModalPrintingSuccess = ({
  onClose,
  timeoutDuration = DEFAULT_MODAL_DURATION_MS
}: ModalPrintingSuccessProps) => {
  return (
    <Modal backdropVariant="success">
      <div className="flex flex-col items-center gap-y-16">
        <ModalIcon icon={faCircleCheck} />

        <ModalTitle size="8xl" variant="normal" weight="black">
          <T _str="Receipt printed" />
        </ModalTitle>
        <p className="text-5xl font-extralight text-kiosk-text-primary">
          <T _str="Thank you for your purchase" />
        </p>
        <ModalButton
          onClick={onClose}
          variant="success"
          size="medium"
          timeoutDuration={timeoutDuration}
        >
          <T _str="Close" />
        </ModalButton>
      </div>
    </Modal>
  );
};
